import { t } from '@lingui/core/macro'
import { TourStep } from '@tecsinapse-org/portal-menu-kit'
import React from 'react'

export const steps = save => [
  {
    content: (
      <TourStep
        title={t`Tipos de Acesso do Usuário`}
        description={t`Para conceder acesso, selecione o perfil do usuário dentro de cada módulo. Após escolher o tipo de Acesso você poderá selecionar as permissões de funcionalidades específicas.`}
      />
    ),
    selector: `#first-product-permissions-select`
  },
  {
    content: (
      <TourStep
        title={t`Permissões`}
        description={t`Defina as funcionalidades específicas que estarão disponíveis ao usuário`}
      />
    ),
    selector: `#first-product-permissions-table`,
    actionAfter: save
  }
]
